import { NgModule, LOCALE_ID } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule, Routes } from '@angular/router';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { MatTabsModule } from '@angular/material/tabs';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { InMemoryWebApiModule } from 'angular-in-memory-web-api';
import { TranslateModule  } from '@ngx-translate/core';
import 'hammerjs';

import { FuseModule } from '@fuse/fuse.module';
import { FuseSharedModule } from '@fuse/shared.module';
import { FuseProgressBarModule, FuseSidebarModule, FuseThemeOptionsModule } from '@fuse/components';

import { fuseConfig } from 'app/fuse-config';

import { FakeDbService } from 'app/fake-db/fake-db.service';
import { AppComponent } from 'app/app.component';
import { AppStoreModule } from 'app/store/store.module';
import { LayoutModule } from 'app/layout/layout.module';
import { AuthGuardService } from './services/auth-guard.service';
import { FormsModule} from '@angular/forms';
import { NgxMaskModule, IConfig } from 'ngx-mask';
import { FuseAlertDialogModule } from '@fuse/components';

import { MatPaginatorIntl } from '@angular/material/paginator';
import { MatPaginatorIntlBr } from './customClass';
import { MatRadioModule } from '@angular/material/radio';

import { FiadorFormComponent } from '../app/main/pages/authentication/fiador-form/fiador-form.component'

import { MatCardModule } from '@angular/material/card';
import { CommonModule } from '@angular/common';
import { LoginConsorciadoComponent } from './main/pages/authentication/login-consorciado/login-consorciado.component';
import { ChangePasswordComponent } from './main/pages/authentication/change-password/change-password.component';
import { registerLocaleData } from '@angular/common';
import localePt from '@angular/common/locales/pt';

registerLocaleData(localePt);

const appRoutes: Routes = [
    {
        path        : 'apps',
        loadChildren: () => import('./main/apps/apps.module').then(m => m.AppsModule)
    },
    {
        path        : 'pages',
        loadChildren: () => import('./main/pages/pages.module').then(m => m.PagesModule)
    },
    {
        path      : 'change-password/:Us/:Sq/:Ac/:vE/:vS',
        component: ChangePasswordComponent
    },
    {
        path      : 'pages/auth/login-consorciado',
        component: LoginConsorciadoComponent
    },
    {
        path      : 'pages/auth/fiador-form',
        component: FiadorFormComponent
    },
    {
        path      : '**',
        redirectTo: 'pages/auth/login'
    },
];

export let options: Partial<IConfig> | (() => Partial<IConfig>);

@NgModule({
    declarations: [
        AppComponent
    ],
    imports     : [
        BrowserModule,
        BrowserAnimationsModule,
        FormsModule,
        HttpClientModule,
        RouterModule.forRoot(appRoutes),

        TranslateModule.forRoot(),
        InMemoryWebApiModule.forRoot(FakeDbService, {
            delay             : 0,
            passThruUnknownUrl: true
        }),

        // Material moment date module
        MatMomentDateModule,

        // Material
        MatButtonModule,
        MatIconModule,
        MatCardModule,
        MatTabsModule,
        MatRadioModule,

        // Fuse modules
        FuseModule.forRoot(fuseConfig),
        FuseProgressBarModule,
        FuseSharedModule,
        FuseSidebarModule,
        FuseThemeOptionsModule,

        // App modules
        LayoutModule,
        AppStoreModule,

        NgxMaskModule.forRoot(options),
        FuseAlertDialogModule,

        CommonModule
    ],
    bootstrap   : [
        AppComponent
    ],
    providers: [
        AuthGuardService,
        { provide: MatPaginatorIntl, useClass: MatPaginatorIntlBr },
        { provide: LOCALE_ID, useValue: 'pt-BR'}
    ]
})
export class AppModule
{
}
